import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
import enTranslations from './locales/en.json';
import esTranslations from './locales/es.json';
import ruTranslations from './locales/ru.json';
import roTranslations from './locales/ro.json';
import ptTranslations from './locales/pt.json';

const resources = {
  en: { translation: enTranslations },
  es: { translation: esTranslations },
  ru: { translation: ruTranslations },
  ro: { translation: roTranslations },
  pt: { translation: ptTranslations },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: false,

    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ['localStorage'],
      caches: ['localStorage'],
      lookupLocalStorage: 'selectedLanguage',
    },
  });

export default i18n;